import { IExportArtifact } from "../ExportArtifacts/IExportArtifact";
import { IModelInfo } from "../ModelInfos/IModelInfo";
import { generateCsharpClass } from "./generateCsharpClass";
import { generateCsharpDataMapping } from "./generateCsharpDataMapping";
import { generateCsharpDomain } from "./generateCsharpDomain";
import { generateGoStruct } from "./generateGoStruct";
import { generateTsInterface } from "./generateTsInterface";
import { IExportGenerator } from "./IExportGenerator";
import { IExportGeneratorService } from "./IExportGeneratorService";

export class ExportGeneratorService implements IExportGeneratorService {
    getExportGenerators(): IExportGenerator[] {
        return [
            { id: "csharp-class", name: "C# Class", generateExportArtifacts: generateCsharpClass },
            { id: "csharp-domain", name: "C# Domain classes", generateExportArtifacts: generateCsharpDomain },
            { id: "csharp-entitymapper", name: "C# Entity DataMapper", generateExportArtifacts: generateCsharpDataMapping },
            { id: "csharp-viewmodel-api", name: "C# WebApi Viewmodel/controller", generateExportArtifacts: generateCsharpClass }, // todo
            { id: "typescript-entitymapper", name: "TypeScript Interface", generateExportArtifacts: generateTsInterface },
            { id: "go-struct", name: "Go struct", generateExportArtifacts: generateGoStruct },
        ];
    }

    generateArtifacts(generators: IExportGenerator[], models: IModelInfo[]): IExportArtifact[] {
        const artifacts: IExportArtifact[] = [];
        for (const generator of generators) {
            artifacts.push(...generator.generateExportArtifacts(models));
        }
        return artifacts;
    }
}